import { Dto } from '@mango/core';
import { Pakbon } from './pakbon';

@Dto({fullName: "CIJBorculo.Logic.CreateFactuur"})
export class createFactuur {
    pakbonnen?: Pakbon[];
    proforma?: boolean;
}
